import { useEffect } from "react";
import { ROUTES } from "src/utils/constants/routes";

function NotFoundPage() {

    useEffect(() => {
        setTimeout(() => {
            window.location.href = ROUTES.GROWW_HOME_PAGE;
        }, 3000);
    }, []);

    return (
        <div className="absolute-center height100 flex flex-col gap-3">
            <div className="displayBase">Page Not Found</div>
            <p>The page you are looking for does not exist.</p>
            <p>Redirecting you to Home Page...</p>
        </div>
    );
}

export default NotFoundPage;
